// Sesi login WINA: token dari API (login) dikirim di header X-Auth-Token setiap request.
import axios from 'axios'

const KUNCI_SESI = ['authenticated', 'auth_token', 'role_id', 'id_user', 'id_unit', 'id_gudang', 'nama', 'unit', 'id_perusahaan', 'foto']

export function getToken() {
  return localStorage.getItem('auth_token') || ''
}

export function hapusSesi() {
  KUNCI_SESI.forEach((k) => localStorage.removeItem(k))
}

// Cabut token di server (abaikan bila gagal), lalu bersihkan sesi di browser
export async function logout() {
  const url = localStorage.getItem('url')
  const token = getToken()
  if (url && token) {
    try {
      await axios.post(url + 'login/logout', {}, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-API-KEY': localStorage.getItem('key'),
        },
        timeout: 5000,
      })
    } catch {
      // token tetap kedaluwarsa sendiri setelah 12 jam tanpa aktivitas
    }
  }
  hapusSesi()
  window.location.hash = '#/pages/login'
  window.location.reload()
}
